<h3 class="text-md py-4 font-bold">Inert Gas Systems</h3>

<form
  #form="ngForm"
  novalidate
>
  <div class="mb-1 flex w-full flex-row">
    <div class="flex-1"></div>
    <nsp-input-label
      class="flex-1"
      label="From"
      alignment="center"
    />
    <nsp-input-label
      class="flex-1"
      label="To"
      alignment="center"
    />
  </div>

  <div class="flex flex-col gap-1">
    @for (
      item of object.values(consumptionsStore.inertGasSystems().entries);
      let i = $index;
      track i
    ) {
      <div class="flex w-full flex-row items-center gap-1">
        <nsp-input-label
          class="flex-1"
          [label]="`Run ${i + 1}`"
        />
        <div class="flex-1">
          <nsp-calendar-input
            [name]="`entries-from-${$index}`"
            [id]="`entries-from-${$index}`"
            [value]="item.from.value"
            [ngModel]="item.from.value"
          />
        </div>
        <div class="flex-1">
          <nsp-calendar-input
            [name]="`entries-to-${$index}`"
            [id]="`entries-to-${$index}`"
            [value]="item.to.value"
            [ngModel]="item.to.value"
          />
        </div>
      </div>
    }
  </div>
</form>
